import styled from '@emotion/styled';
import React from 'react';
import { Spinner } from '../../shared/Spinner';

export const LoadingSpinner = () => {
  return (
    <SpinnerWrapper>
      <Spinner type="circle" />
    </SpinnerWrapper>
  );
};

const SpinnerWrapper = styled.div`
  width: 34px;
  height: 34px;
`;
